export default __webpack_public_path__ + "media/review-save.b5e95314.png";